import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TableWrapper = styled.div`
  width: fit-content;
  overflow-x: auto;
`;

const tableColumns = [
  {
    columns: [
      {
        Header: 'Country',
        accessor: 'type',
        width: 200,
      },
      {
        Header: 'Assigned Students',
        accessor: 'total',
        width: 200,
      },
      {
        Header: 'Active Students',
        accessor: 'active',
        width: 200,
      },
      {
        accessor: 'position',
        width: 0,
        show: false,
      },
    ],
  },
];

class StudentTable extends PureComponent {
  render() {
    const { studentData } = this.props;
    const sortByPosition = [{ id: 'position', desc: false }];

    return (
      <TableWrapper>
        <ReactTable
          data={studentData}
          defaultPageSize={3}
          className="-striped -highlight"
          columns={tableColumns}
          defaultSorted={sortByPosition}
          style={{ textAlign: 'center' }}
        />
      </TableWrapper>
    );
  }
}

StudentTable.propTypes = {
  studentData: PropTypes.arrayOf(PropTypes.shape({})),
};

StudentTable.defaultProps = {
  studentData: null,
};

export default StudentTable;
